export default function EventCheckIcon() {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.5 4.09091C12.3329 4.09091 4.09091 12.3329 4.09091 22.5C4.09091 32.6671 12.3329 40.9091 22.5 40.9091C32.6671 40.9091 40.9091 32.6671 40.9091 22.5C40.9091 12.3329 32.6671 4.09091 22.5 4.09091ZM0 22.5C0 10.0736 10.0736 0 22.5 0C34.9264 0 45 10.0736 45 22.5C45 34.9264 34.9264 45 22.5 45C10.0736 45 0 34.9264 0 22.5ZM33.1509 14.9173C33.9497 15.7161 33.9497 17.0112 33.1509 17.81L20.8782 30.0827C20.0794 30.8815 18.7843 30.8815 17.9855 30.0827L11.8491 23.9464C11.0503 23.1476 11.0503 21.8524 11.8491 21.0536C12.6479 20.2548 13.943 20.2548 14.7418 21.0536L19.4318 25.7437L30.2582 14.9173C31.057 14.1185 32.3521 14.1185 33.1509 14.9173Z"
        fill="#25D366"
      />
    </svg>
  );
}
